import { render, staticRenderFns } from "./ConnectMetaMask.vue?vue&type=template&id=680d07bf&scoped=true&"
import script from "./ConnectMetaMask.vue?vue&type=script&lang=js&"
export * from "./ConnectMetaMask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680d07bf",
  null
  
)

export default component.exports